export default function PageHero({ overline, title, description, image }) {
  return (
    <section className="relative overflow-hidden border-b border-slate-200 bg-slate-50">
      <div className="container-page grid gap-10 py-16 md:grid-cols-12 md:py-20">
        <div className="md:col-span-7">
          {overline && <div className="overline mb-4">{overline}</div>}
          <h1 className="font-heading text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">{title}</h1>
          {description && (
            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-600">{description}</p>
          )}
        </div>
        {image && (
          <div className="md:col-span-5">
            <div className="aspect-[4/3] overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
              <img src={image} alt="" className="h-full w-full object-cover" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
